let activeLocks = 0
let originalBodyOverflow = ''
let originalDocumentOverflow = ''

/** 多个弹窗同时打开时，使用计数避免子弹窗提前解除背景页滚动锁。 */
export const usePageScrollLock = () => {
  let isLocked = false

  /** 为当前弹窗锁定 body 与根节点滚动容器。 */
  const lock = () => {
    if (!import.meta.client || isLocked) {
      return
    }

    if (activeLocks === 0) {
      originalBodyOverflow = document.body.style.overflow
      originalDocumentOverflow = document.documentElement.style.overflow
      document.body.style.overflow = 'hidden'
      document.documentElement.style.overflow = 'hidden'
    }

    activeLocks += 1
    isLocked = true
  }

  /** 仅释放当前弹窗的锁，不影响仍处于打开状态的其他弹窗。 */
  const unlock = () => {
    if (!import.meta.client || !isLocked) {
      return
    }

    activeLocks -= 1
    isLocked = false

    if (activeLocks === 0) {
      document.body.style.overflow = originalBodyOverflow
      document.documentElement.style.overflow = originalDocumentOverflow
      originalBodyOverflow = ''
      originalDocumentOverflow = ''
    }
  }

  return { lock, unlock }
}
